import React from "react";
import "./Strategies.css";
import { motion } from "framer-motion";

const fadeUp = {
  hidden: { opacity: 0, y: 18 },
  show: { opacity: 1, y: 0, transition: { duration: 0.65 } },
};

const items = [
  {
    title: "Brand-aware flows",
    description: "Different printers and extenders fail in different ways — our paths match the device you own.",
  },
  {
    title: "Fewer dead ends",
    description: "We surface the next best action instead of dumping you into a wall of generic FAQ text.",
  },
  {
    title: "Human backup",
    description: "When firmware blocks or pairing loops hit, a specialist can take over without restarting from zero.",
  },
  {
    title: "Home & office ready",
    description: "From a single desk printer to multi-room Wi‑Fi coverage, the same calm process applies.",
  },
];

const Strategies = () => (
  <section className="strat" aria-label="Approach">
    <div className="strat__page">
      <p className="strat__kicker">Our approach</p>
      <h1 className="strat__pageTitle">Built for real homes and small offices</h1>
      <p className="strat__pageSub">
        Whether it’s a first printer or a weak Wi‑Fi corner, we focus on fixes you can finish today.
      </p>
    </div>
    <div className="strat__grid">
      {items.map((item, index) => (
        <motion.article
          className="strat__card"
          key={item.title}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.2 }}
          variants={fadeUp}
          transition={{ delay: index * 0.05 }}
        >
          <h3 className="strat__h3">{item.title}</h3>
          <p className="strat__p">{item.description}</p>
        </motion.article>
      ))}
    </div>
  </section>
);

export default Strategies;
